<template>
  <div>
    <Head :title="$t('treatments.treatments')"/>
    <h1 class="mb-8 text-3xl font-bold">{{ $t('treatments.treatments') }}</h1>
    <table-head-filter :buttons="buttons"/>
    <Table
      :resource="data"
      class="custom-table-layout rounded"
      url-to-view="applicants"
      cookie-name="personal-treatments"
      :remember-table="true"
    >
      <template #cell(date)="{ item: data }">
        {{ $filters.formatDate(data.date) }}
      </template>
      <template #cell(latest_intervention)="{ item: data }">
        {{ $filters.formatDate(data.latest_intervention) }}
      </template>
      <template #cell(date_closed)="{ item: data }">
        {{ (data.status.value == 3) ? $filters.formatDate(data.date_closed) : '' }}
      </template>
      <template #cell(status)="{ item: data }">
        <status-badge :status="data.status"/>
      </template>
      <template #cell(employees)="{ item: data }">
        <badge v-for="(employee, key) in data.employees" v-bind:key="key" :text="employee"/>
      </template>
      <template #cell(volunteer)="{ item: data }">
        <badge :text="data.volunteer"/>
      </template>
    </Table>
  </div>
</template>
<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import Table from '@/Shared/Table/Components/Table'
import TableHeadFilter from '@/Shared/TableHeadFilter'
import StatusBadge from '@/Shared/StatusBadge'
import Badge from '@/Shared/Badge'

export default {
  components: {
    Head,
    Table,
    TableHeadFilter,
    StatusBadge,
    Badge
  },
  layout: Layout,
  props: {
    data: Object,
    buttons: Array,
  }
}
</script>
